import { Injectable } from '@angular/core';
import {AuthProviders, AngularFireAuth, FirebaseAuthState, AuthMethods, AngularFire} from 'angularfire2';

@Injectable()
export class AuthService {
  protected authState: FirebaseAuthState;

  constructor(public af: AngularFire, public auth$: AngularFireAuth) {
    this.authState = auth$.getAuth();

    auth$.subscribe((state: FirebaseAuthState) => {
      this.authState = state;
    });
  }

  get authenticated(): boolean {
   // console.log(this.authState + ' is the status for authentication');
    return this.authState !== null;
  }
  
  get id(): string {
    return this.authenticated ? this.authState.uid : '';
  }

  signUp(email: string, password: string): firebase.Promise<FirebaseAuthState> {
    let creds: any = { email: email, password: password };
    return this.auth$.createUser( creds );
  }

  signInWithFirebaseCredentials(email: string, password: string): firebase.Promise<FirebaseAuthState> {
    console.log('logging in with firebase credentials');

    return this.auth$.login({
        email: email,
        password: password,
      },
      {
        provider: AuthProviders.Password,
        method: AuthMethods.Password
      });
  }


  signInWithFacebook(): firebase.Promise<FirebaseAuthState> {
    return this.auth$.login({
      provider: AuthProviders.Facebook,
      method: AuthMethods.Popup
    });
  }

  signInWithGoogle(): firebase.Promise<FirebaseAuthState> {
    return this.auth$.login({
      provider: AuthProviders.Google,
      method: AuthMethods.Popup
    });
  }

  signOut(): void {
    this.auth$.logout();
  }

  displayName(): string {
    if (this.authState != null && this.authState.facebook) {
      return this.authState.facebook.displayName;
    } else if (this.authState != null && this.authState.google) {
      return this.authState.google.displayName;
    } else if (this.authState != null && this.authState.auth) {
      return this.authState.auth.displayName;
    } else {
      return '';
    }
  }

  displayEmail(): string {
    if (this.authState != null && this.authState.facebook) {
      return this.authState.facebook.email;
    } else if (this.authState != null && this.authState.google) {
      return this.authState.google.email;
    } else if (this.authState != null && this.authState.auth) {
      return this.authState.auth.email;
    } else {
      return '';
    }
  }
}


// WEBPACK FOOTER //
// ./src/providers/auth-service.ts